import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../alg-auth';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  getTasksForCurrentUser(en_cours = true, searchTerm: string = null, offset: number = 0, limit: number = 15) {
    const endpointUrl = window.location.origin + '/alfresco/api/-default-/public/workflow/versions/1/tasks/';
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const user = this.escapeQueryValue(this.authService.getUsername());
    const term = this.escapeQueryValue(searchTerm?.trim() || '');
    const clauses = [`assignee='${user}'`, `status='${en_cours ? 'active' : 'completed'}'`];
    if (term) {
      clauses.push(`(name MATCHES '${term}' OR description MATCHES '${term}')`);
    }
    const params = new HttpParams()
      .set('where', `(${clauses.join(' AND ')})`)
      .set('skipCount', offset)
      .set('maxItems', limit);
    return this.http.get(endpointUrl, { headers, params });
  }

  private escapeQueryValue(value: string): string {
    return (value || '').replace(/['\\]/g, '\\$&');
  }

  getById(taskId: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getForm(taskId: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}/task-form-model`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getVariables(taskId: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}/variables`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpointUrl, params);
  }
  getTaskInstance(taskId: string) {
    let apiUrl = window.location.origin + `/alfresco/s/api/task-instances/activiti$${taskId}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(`${apiUrl}`, params);
  }

  getChildrenNodes(bpm_package: any) {
    let apiUrl = window.location.origin + '/alfresco/api/-default-/public/workflow/versions/1/tasks';
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(`${apiUrl}/${bpm_package}/children`, params);
  }

  getProperties(className: string) {
    let apiUrl = window.location.origin +  '/alfresco/api/-default-/public/alfresco/versions/1/types';
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(`${apiUrl}/${className}`, params);
  }

  postTask(taskId: string, body: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}/variables`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.post(endpointUrl, body, params);
  }

  putTask(taskId: string, body: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}?select=state`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.put(endpointUrl, body, params);
  }

  getItems(taskId: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/tasks/${taskId}/items`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getTasksFromProcess(processId: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}/tasks`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = { headers: headers};
    return this.http.get(endpointUrl, params);
  }
}
